import { useEffect, useState } from 'react';
import axios from 'axios';

/**
 * Hook that will retrieve the Drupal session token for the current user
 * (inluding anonymous users).  If no token is received OR there is an error
 * while retrieving it, will run the errHandler (if one is provided).
 */
const useDrupalCsrfToken = (errHandler) => {
  const [csrfToken, setCsrfToken] = useState(null);

  useEffect(() => {
    axios
      .get('/rest/session/token')
      .then((response) => {
        if (response.data) {
          setCsrfToken(response.data);
        }
      })
      .catch((err) => {
        console.error(err);
        if (errHandler) {
          errHandler(err);
        }
      });
  }, [errHandler]);

  return csrfToken;
};

export default useDrupalCsrfToken;
